import script from "./TheMainDock.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheMainDock.vue?vue&type=script&lang=ts&setup=true"

import "./TheMainDock.vue?vue&type=style&index=0&id=1385d573&lang=sass"

const __exports__ = script;

export default __exports__